import { createFileRoute, redirect } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { TokenManager } from '../auth/TokenManager';
import { queries } from '../common/api/queryKeys/queries';
import { AdminRfqOverviewPage } from '../rfq/overview/AdminRfqOverviewPage';
import { Role } from '../user/model/role.model';
import { SessionService } from '../user/session/SessionService';

const rfqSearchSchema = z.object({
    searchQuery: z.string().optional(),
    customerIds: z.array(z.string()).optional(),
    supplierIds: z.array(z.string()).optional(),
    page: fallback(z.number(), 0).default(0),
    tab: fallback(z.string(), 'enquired').default('enquired'),
    sortValue: fallback(
        z.object({
            sortField: z.string(),
            sortDirection: z.string(),
        }),
        {
            sortField: 'dateUpdated',
            sortDirection: 'DESC',
        }
    ).default({
        sortField: 'dateUpdated',
        sortDirection: 'DESC',
    }),
});

export const Route = createFileRoute('/_app/requests-for-quotes/')({
    component: AdminRfqOverviewPage,
    validateSearch: zodSearchValidator(rfqSearchSchema),
    beforeLoad: async ({ context }) => {
        const token = await TokenManager.getInstance().getToken();
        const role = await context.queryClient.ensureQueryData<Role>({
            queryKey: queries.role.information.queryKey,
            queryFn: () => SessionService.getInstance().loadRoleInformation(token),
        });

        if (!role.isSuperAdmin()) {
            throw redirect({ to: '/dashboard' });
        }
    },
});
